<div *ngIf="locked">
  <ng-container *ngIf="duration">
    Your account is temporarily locked. Try again in <wf-countdown-timer [duration]="duration"></wf-countdown-timer>
  </ng-container>
  <ng-container *ngIf="!duration">
    Your account has been temporarily locked because of too many failed login attempts. Try again in <span class="bold">15 minutes</span>
  </ng-container>
</div>
<div *ngIf="!locked">
  <div>The username or password you entered is incorrect.</div>
  <div>
    <span class="bold">{{ attemptsRemaining }}</span> more failed attempts will temporarily lock your account
  </div>
</div>
<div class="padding-top-10">
  Forget your <a href="/forgot-password">password</a>?
</div>
